import { Position, Toaster } from '@blueprintjs/core'

export const Toast = Toaster.create({
  position: Position.TOP
})



// WEBPACK FOOTER //
// ./src/Toaster.js